/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps, no-dupe-keys */
import React, { useEffect, useRef, useState } from 'react';
import { fabric } from 'fabric';
import CustomBoundingBox from './CustomBoundingBox';
import ResizeLogicComponent from './ResizeLogicComponent';
import DuplicateLogicComponent from './DuplicateLogicComponent';
import ProductImageComponentOne from './ProductImageComponentOne';
import WorkingAreaComponent from './WorkingAreaComponent';
import DesignAreaComponentOne from './DesignAreaComponentOne';
import cursorGrab from '../assets/cursors/cursor-grab.svg';
import cursorGrabbed from '../assets/cursors/cursor-grabbed.svg';
// import HistoryDisplay from './HistoryDisplay';
import "../style.css"
// Load images
import Path from './path-warpnew';

import undoHoverImage from '../assets/undohover.png';
import undoInactiveImage from '../assets/undoinactive.png';
import undoActiveImage from '../assets/undoactive.png';
import redoHoverImage from '../assets/redohover.png';
import redoInactiveImage from '../assets/redoinactive.png';
import redoActiveImage from '../assets/redoactive.png';
import priceTableData from "../json/complete_price_table.json";
import EmbrioderyPrice from "../json/priceEmbroidery.json";
import { replaceCurveTextObject } from './CurveTextComponent';
import {
  constrainObjectToDesignAreaBounds,
  restoreObjectDesignAreaMetrics,
  syncObjectDesignAreaMetrics,
} from '../utils/designAreaConstraints';



fabric.Canvas.prototype.getObjectById = function (id) {
  return this.getObjects().find(obj => obj.id === id);
};
// const extractColorsFromObject = (obj, includeStroke = true) => {
//   const colors = new Set();

//   const hexToRgb = (hex) => {
//     if (!/^#([0-9A-F]{3}){1,2}$/i.test(hex)) return hex;

//     let c = hex.substring(1).split('');
//     if (c.length === 3) {
//       c = [c[0], c[0], c[1], c[1], c[2], c[2]];
//     }
//     const r = parseInt(c[0] + c[1], 16);
//     const g = parseInt(c[2] + c[3], 16);
//     const b = parseInt(c[4] + c[5], 16);

//     return `rgb(${r}, ${g}, ${b})`;
//   };

//   const addColor = (color) => {
//     if (!color) return;
//     const normalizedColor = color.startsWith("#") ? hexToRgb(color) : color;
//     colors.add(normalizedColor);
//   };

//   if (obj.type === 'group') {
//     obj.getObjects().forEach((childObj) => {
//       addColor(childObj.fill);
//       if (includeStroke) addColor(childObj.stroke);
//     });
//   } else if (obj.type === 'image') {
//     // Check if the image has palette colors
//     if (obj.paletteColors && obj.paletteColors.length > 0) {
//       obj.paletteColors.forEach((color) => {
//         addColor(`rgb(${color[2]}, ${color[1]}, ${color[0]})`);
//       });

//       if (obj.bgRemove && obj.paletteColors.length > 0) {
//         const dominantColor = `rgb(${obj.paletteColors[0][2]}, ${obj.paletteColors[0][1]}, ${obj.paletteColors[0][0]})`;
//         colors.delete(dominantColor);
//       }
//     } else {
//       // If the image lacks palette colors, assume it is full-color
//       obj.isFullColor = true;
//       obj.set('isFullColor', true)
//     }
//   } else {
//     addColor(obj.fill);
//   }

//   if (includeStroke) {
//     addColor(obj.stroke);
//   }

//   console.log('Extracted Colors:', Array.from(colors));
//   console.log('Total Colors:', colors.size);
//   console.log('Is Full Color Image:', obj.isFullColor);

//   return Array.from(colors);
// };

const extractColorsFromObject = (obj, includeStroke = true) => {
  const colors = new Set();

  const hexToRgb = (hex) => {
    if (!/^#([0-9A-F]{3}){1,2}$/i.test(hex)) return hex;

    let c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    const r = parseInt(c[0] + c[1], 16);
    const g = parseInt(c[2] + c[3], 16);
    const b = parseInt(c[4] + c[5], 16);

    return `rgb(${r}, ${g}, ${b})`;
  };

const addColor = (color) => {
  if (!color || color === "none") return;

  // Skip if string is rgba and alpha is 0
  if (typeof color === 'string' && color.startsWith("rgba")) {
    const parts = color.replace(/[^\d.,]/g, '').split(','); // Extract numbers
    if (parts.length === 4 && parseFloat(parts[3]) === 0) return; // Alpha = 0
  }

  const normalizedColor = color.startsWith("#") ? hexToRgb(color) : color;
  colors.add(normalizedColor);
};


  if (obj.type === 'group') {
    obj.getObjects().forEach((childObj) => {
      addColor(childObj.fill);
      if (includeStroke) addColor(childObj.stroke);
    });
  } else if (obj.type === 'image') {
    if (obj.singleColorMode) {
      addColor(`rgb(${obj.singleColor.r}, ${obj.singleColor.g}, ${obj.singleColor.b})`);
      obj.isFullColor = false;
    } else if (obj.makeColorMode) {
      addColor(`rgb(${obj.makeColor.r}, ${obj.makeColor.g}, ${obj.makeColor.b})`);
      obj.isFullColor = false;
    } else if (obj.paletteColors && obj.paletteColors.length > 0) {
 obj.paletteColors.forEach((color) => {
  // Skip color if alpha = 0 (fully transparent)
  if (color.length === 4 && color[3] === 0) return;

  addColor(`rgba(${color[2]}, ${color[1]}, ${color[0]}, ${color[3] !== undefined ? color[3] / 255 : 1})`);
});


      // Remove dominant color if bgRemove is active
    if (obj.bgRemove && obj.paletteColors?.length > 0) {
  const [b, g, r, a = 255] = obj.paletteColors[0];
  const dominantColor = `rgba(${r}, ${g}, ${b}, ${a / 255})`;
  colors.delete(dominantColor);
}

      obj.isFullColor = false; // Not full color if paletteColors exist
    } else {
      // If no color modes and no palette colors, assume full-color image
      obj.isFullColor = true;
      obj.set('isFullColor', true);
    }
  } else {
    addColor(obj.fill);
  }

  if (includeStroke) {
    addColor(obj.stroke);
  }

  console.log('Extracted Colors:', Array.from(colors));
  console.log('Total Colors:', colors.size);
  console.log('Is Full Color Image:', obj.isFullColor);

  return Array.from(colors);
};


const CanvasComponentOne = ({setGetValue, setImagecaptureFront, influencerid, switchBar, setCanvasRef, updateSelectedObjectSize, onObjectSelected, canvasKey, addToHistory, history, setHistory, saveCanvasDataToLocalStorage, updateCanvasPrice, isPriceSidebarVisible, Canvasid, pid, quantity, designId }) => {
  const canvasRef = useRef(null);
  const [canvas, setCanvas] = useState(null);
  const [productImage, setProductImage] = useState(null);

  const hasCapturedRef = useRef(false);

  const [controlSettings, setControlSettings] = useState({
    enableCorners: true,
    cornerSize: 30,
    cornerColor: 'blue',
    cornerStrokeColor: 'red',
    borderColor: 'rgb(8, 149, 169)',
    borderOpacityWhenMoving: 0.8,
    borderScaleFactor: 2,
    iconSize: 30,
    iconOpacity: 1.0,
  });
  const [designArea, setDesignArea] = useState(null);
  const [activePart, setActivePart] = useState('Front');
  const [selectedPart, setSelectedPart] = useState(null);
  const [workingArea, setWorkingArea] = useState(null);
  const [initialState, setInitialState] = useState(null);


  // console.log('switchBarcanvascomponent',switchBar);
  const [isSwitchingTab, setIsSwitchingTab] = useState(false);

  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  const generateUniqueId = () => `_${Math.random().toString(36).substr(2, 9)}`;
  const historyObjectProps = ['left','clipartOriginalColors', 'clipartPath',  'color',
    'id','originKey','original_url','originalPalette',
   'mode',
   'type',
   'alpha',
   'bgremove',
   'rotation',
   'angle',
   'singleColor',
   'imageFile',
     'colorMap',

   'makeColor',
   'makeOneColor',
   'singleColorMode',
   'makeColorMode', 'filters', 'top','originalText', 'scaleX','letterSpacing',
   'scaleY', 'src','dominantColor',"dominant_color", 'topPercent', 'leftPercent', 'paletteColors','bend','warpType', 'session_id','originalPath',
 'distortH',
 'distortV',
    'fontPath',
 'fontFamily',
 'fill',
 'stroke',
 'strokeWidth',
 'strokeColor',
 'bgRemove',
 'bringToFront',
 'center',
 "isFullColor",
 'designElement',
 'isAddedText',
 'isAddedClipart',
 'curve',
 'curveTextSettings',
  ];

  const createRemoveHistoryItem = (obj) => {
    const prevState = obj.toObject(historyObjectProps);

    if (obj.group?.type === 'activeSelection') {
      const transform = fabric.util.qrDecompose(obj.calcTransformMatrix());

      Object.assign(prevState, {
        left: transform.translateX,
        top: transform.translateY,
        scaleX: transform.scaleX,
        scaleY: transform.scaleY,
        skewX: transform.skewX,
        skewY: transform.skewY,
        angle: transform.angle,
        originX: 'center',
        originY: 'center',
      });
    }

    return {
      objId: obj.id,
      prevState,
      newState: null,
      action: 'remove',
    };
  };

  const normalizeRestoredObjectPosition = (obj, state) => {
    if (!obj || state?.originX !== 'center' || state?.originY !== 'center') return;

    const center = new fabric.Point(state.left, state.top);
    obj.set({
      originX: 'left',
      originY: 'top',
    });
    obj.setPositionByOrigin(center, 'center', 'center');
    obj.setCoords();
  };

  useEffect(() => {
    const canvasElement = canvasRef.current;
    const newCanvas = new fabric.Canvas(canvasElement, {
      selection: true,
      selectionColor: 'rgba(255, 255, 255, 0.3)',
      selectionBorderColor: 'white',
      selectionLineWidth: 0.7,
    });

    newCanvas.defaultCursor = 'default';
    newCanvas.hoverCursor = `url(${cursorGrab}), auto`;
    newCanvas.moveCursor = `url(${cursorGrabbed}), auto`;
    setCanvas(newCanvas);
    setCanvasRef(newCanvas);
    window._canvas = newCanvas;

    const updateCanvasSize = () => {
      const canvasContainer = canvasElement.parentNode;
      const containerWidth = canvasContainer.clientWidth;
      const containerHeight = canvasContainer.clientHeight;

      newCanvas.setWidth(containerWidth);
      newCanvas.setHeight(containerHeight);
      newCanvas.renderAll();
      console.log('Updated canvas size:', containerWidth, containerHeight);
    };

    updateCanvasSize();
    window.addEventListener('resize', updateCanvasSize);

    return () => {
      window.removeEventListener('resize', updateCanvasSize);
      setCanvasRef(null);
      if (window._canvas === newCanvas) {
        window._canvas = null;
      }
      newCanvas.dispose();
    };
  }, [setCanvasRef]);

  useEffect(() => {
    if (canvas) {
      const onObjectModified = (e) => {
        if (canvas.__isHistoryRestoring) return;
        if (!isSwitchingTab && e.transform) {
          const obj = e.target;
          const prevState = { ...obj.originalState };
          let newState = obj.toObject(['left','filters',  'color','clipartOriginalColors', 'clipartPath',
            'mode',
            'type',
            'alpha',
              'colorMap',

            'angle',
             'id','originKey','original_url','originalPalette',
            
            'bgremove',
            'bringToFront',
            'center',
            'singleColor',
            'MakeColor',
            'makeOneColor',
            'singleColorMode',
            'makeColorMode',  'top', 'scaleX', 'scaleY','letterSpacing','originalText',           // Save singleColorMode (true/false)
            'src','fill','dominantColor',"dominant_color", 'topPercent','imageFile','bgRemove','rotation', 'leftPercent', 'paletteColors', 'session_id','originalPath','bend','warpType','distortH',
            'distortV','isFullColor','strokewidth','stroke','designElement','isAddedText','curve','curveTextSettings','fontPath','fontFamily'
          ]);
          updateObjectProportions(obj);
          constrainObjectToDesignArea(obj);
          updateObjectProportions(obj);
          newState = obj.toObject(historyObjectProps);
// Clear redo stack whenever a new modification happens
setHistory(prev => ({ ...prev, redo: [] }));
addToHistory(obj, prevState, newState, 'modify');
          
          obj.originalState = newState;
          saveObjectToLocalStorage(obj, canvasKey);
          saveCanvasDataToLocalStorage(canvasKey);  // Save data after any object modification


  
          calculatePrice();
        }
      };
  
  
        const onObjectScaling = (e) => {
          constrainObjectScaling(e.target);
        };
  
        const onObjectMoving = (e) => {
          constrainObjectToDesignArea(e.target);
        };

  
        const handleObjectAdded = (e) => {
          if (canvas.__isHistoryRestoring) return;
          const obj = e.target;
          if (obj.designElement) {
            obj.partName = `${designId}_${canvasKey}`;
            obj.id = obj.id || generateUniqueId();
            obj.originalState = obj.toObject(['left','clipartOriginalColors', 'clipartPath',  'color',
              'mode',
              'type',
              'alpha',
              'rotation',
              'bgremove',
              'singleColor',
              'makeColor',
              'angle',
               'originKey','original_url','originalPalette',
              'id',
               'colorMap',

              'makeOneColor',
              'dominantColor'
              ,"dominant_color",
              'singleColorMode',
              'makeColorMode', 'filters','imageFile','originalText','strokeColor','letterSpacing',         // Save singleColorMode (true/false)
  'top', 'scaleX', 'scaleY', 'src','fill', 'topPercent','bgRemove', 'leftPercent', 'paletteColors', 'session_id', 'originalPath','bend','warpType','distortH',
            'distortV','stroke','strokeWidth', 'bringToFront',
            'center','isFullColor','designElement','isAddedText','curve','curveTextSettings','fontPath','fontFamily']);
            updateObjectProportions(obj);
                    constrainObjectToDesignArea(obj);
  
            addToHistory(obj, null, obj.originalState, 'add');
            saveCanvasDataToLocalStorage(canvasKey);

  
            saveObjectToLocalStorage(obj, canvasKey);
            calculatePrice(); // Call calculatePrice on object addition
          }
        };
  
        const handleObjectRemoved = (e) => {
          if (canvas.__isHistoryRestoring) return;
          const obj = e.target;
          if (obj.designElement) {
            const removeHistoryItem = createRemoveHistoryItem(obj);

            if (Array.isArray(canvas.__pendingRemovalBatch)) {
              canvas.__pendingRemovalBatch.push(removeHistoryItem);
            } else {
              addToHistory(obj, removeHistoryItem.prevState, null, 'remove');
            }
            removeObjectFromLocalStorage(obj.id, canvasKey);
            calculatePrice(); // Call calculatePrice on object removal
          }
        };

        const handleObjectsRemoved = (e) => {
          const items = e.objects || [];
          if (!items.length) return;

          setHistory(prev => ({
            undo: [
              ...prev.undo,
              {
                objId: items.map(item => item.objId).join(','),
                prevState: null,
                newState: null,
                action: 'removeGroup',
                items,
              },
            ],
            redo: [],
          }));
        };
  
        canvas.on('object:modified', onObjectModified);
        canvas.on('object:scaling', onObjectScaling);
        canvas.on('object:moving', onObjectMoving);
        canvas.on('object:added', handleObjectAdded);
        canvas.on('object:removed', handleObjectRemoved);
        canvas.on('objects:removed', handleObjectsRemoved);
  
        return () => {
          canvas.off('object:modified', onObjectModified);
          canvas.off('object:scaling', onObjectScaling);
          canvas.off('object:moving', onObjectMoving);
          canvas.off('object:added', handleObjectAdded);
          canvas.off('object:removed', handleObjectRemoved);
          canvas.off('objects:removed', handleObjectsRemoved);
        };
      }
    }, [canvas, designArea, productImage, canvasKey, isSwitchingTab,  initialState]);

    useEffect(() => {
      const handleResize = debounce(() => {
        if (canvas && designArea) {
    
          canvas.getObjects().forEach((obj) => {
            if (obj.designElement) {
              restoreObjectDesignAreaMetrics(obj, designArea);
            }
          });
          canvas.renderAll();
        }
      }, 100);  // Adding a 100ms debounce to prevent excessive triggering

      handleResize();
    
      window.addEventListener('resize', handleResize);
      canvas?.on('object:added', handleResize);
    
      return () => {
        window.removeEventListener('resize', handleResize);
        canvas?.off('object:added', handleResize);
      };
    }, [canvas, designArea]);

  const updateObjectProportions = (obj) => {
    if (obj.designElement && designArea) {
      syncObjectDesignAreaMetrics(obj, designArea);
    }
  };

  const constrainObjectToDesignArea = (obj) => {
    constrainObjectToDesignAreaBounds(obj, designArea, canvas);
  };

  const constrainObjectScaling = (obj) => {
    constrainObjectToDesignAreaBounds(obj, designArea, canvas);
  };

  const captureObjectState = (obj) => {
    const state = obj.toObject(['left', 'top', 'scaleX', 'scaleY', 'angle', 'fill', 'topPercent', 'leftPercent','bend','warpType','stroke', 'strokeWidth', 'paletteColors','src']);
    if (obj.type === 'group') {
      state.objects = obj.getObjects().map(child => child.toObject(['left', 'top', 'scaleX', 'scaleY', 'angle', 'fill', 'topPercent', 'leftPercent','stroke', 'strokeWidth', 'paletteColors','src']));
    }
    return state;
  };
  const reformatSvgPath = (svgPath) => {
    const pathCommands = svgPath.match(/[MmLlHhVvCcSsQqTtAaZz]|-?\d*\.?\d+/g);
    let reformattedPath = '';

    for (let i = 0; i < pathCommands.length; i++) {
      const command = pathCommands[i];
      if (/[MmLlHhVvCcSsQqTtAaZz]/.test(command)) {
        reformattedPath += `\n${command}`;
      } else {
        reformattedPath += ` ${command}`;
      }
    }

    return reformattedPath;
  };
const applyObjectState = async (obj, state) => {
  if (obj?.canvas && state?.curveTextSettings) {
    const activeCanvas = obj.canvas;
    activeCanvas.__isHistoryRestoring = true;

    return replaceCurveTextObject({
      activeCanvas,
      currentObject: obj,
      selectAfterReplace: false,
      updates: {
        ...state.curveTextSettings,
        ...state,
        curve: state.curveTextSettings.curve ?? state.curve,
        spacing: state.curveTextSettings.spacing ?? state.letterSpacing,
        fontSize: state.curveTextSettings.fontSize,
      },
    }).then((restoredObj) => {
      if (!restoredObj) return;

      const savedVisualWidth = Number(state.width) * Number(state.scaleX || 1);
      const savedVisualHeight = Number(state.height) * Number(state.scaleY || 1);
      const restoredScaleX =
        Number.isFinite(savedVisualWidth) && restoredObj.width
          ? savedVisualWidth / restoredObj.width
          : state.scaleX;
      const restoredScaleY =
        Number.isFinite(savedVisualHeight) && restoredObj.height
          ? savedVisualHeight / restoredObj.height
          : state.scaleY;

      restoredObj.set({
        id: obj.id,
        left: state.left,
        top: state.top,
        scaleX: restoredScaleX,
        scaleY: restoredScaleY,
        angle: state.angle,
        opacity: state.opacity,
        flipX: state.flipX,
        flipY: state.flipY,
        designElement: state.designElement !== undefined ? state.designElement : true,
        isAddedText: state.isAddedText || Boolean(state.curveTextSettings),
        isAddedClipart: false,
        curveTextSettings: state.curveTextSettings,
      });
      restoredObj.originalState = { ...state };
      restoredObj.setCoords();
      activeCanvas.discardActiveObject();
      onObjectSelected?.(null);
      activeCanvas.renderAll();
      return restoredObj;
    }).finally(() => {
      activeCanvas.__isHistoryRestoring = false;
    });
  }

  if (obj?.canvas && state?.type && obj.type !== state.type) {
    const canvas = obj.canvas;
    const objectIndex = canvas.getObjects().indexOf(obj);
    canvas.__isHistoryRestoring = true;

    fabric.util.enlivenObjects([state], (objects) => {
      const newObj = objects[0];

      if (!newObj) {
        canvas.__isHistoryRestoring = false;
        return;
      }

      newObj.set({
        id: obj.id,
        designElement: state.designElement !== undefined ? state.designElement : true,
        isAddedText: state.isAddedText || Boolean(state.curveTextSettings),
        isAddedClipart: state.curveTextSettings ? false : state.isAddedClipart,
        curveTextSettings: state.curveTextSettings,
      });

      canvas.remove(obj);
      if (objectIndex >= 0) {
        canvas.insertAt(newObj, objectIndex, false);
      } else {
        canvas.add(newObj);
      }
      canvas.setActiveObject(newObj);
      newObj.originalState = { ...state };
      newObj.setCoords();
      canvas.renderAll();
      canvas.__isHistoryRestoring = false;
    });
    return;
  }

  // Apply general properties
  obj.set({
    left: state.left,
    top: state.top,
    scaleX: state.scaleX,
    scaleY: state.scaleY,
    angle: state.angle,
    fill: state.fill,
    opacity: state.opacity,
    flipX: state.flipX,
    flipY: state.flipY,
      originalPath: state.originalPath,
      warpType: state.warpType,
      curve: state.curve,
      curveTextSettings: state.curveTextSettings,
      designElement: state.designElement,
      isAddedText: state.isAddedText || Boolean(state.curveTextSettings),
      isAddedClipart: state.curveTextSettings ? false : state.isAddedClipart,
      bend: state.bend,
      distortH: state.distortH,
      distortV: state.distortV,
      paletteColors: state.paletteColors || [],
       stroke: state.stroke, // Ensure stroke color is applied
    strokeWidth: state.strokeWidth, // Ensure stroke width is applied
    skewX: state.skewX,
    bringToFront:state.bringToFront,
    center:state.center,
          singleColor: state.singleColor,
      singleColorMode: state.singleColorMode,
      makeColor: state.makeColor,
      makeColorMode: state.makeColorMode,
    skewY: state.skewY,
    originKey:state.originalKey,
    originalPalette:state.originalPalette,
    originalImagePath:state.originalImagePath,
    colorMap:state.colorMap,
   
 
     stroke: state.stroke, // Ensure stroke color is applied
    strokeWidth: state.strokeWidth, // Ensure stroke width is applied
    selectable: state.selectable !== undefined ? state.selectable : true,
    evented: state.evented !== undefined ? state.evented : true,


  });
if (obj.type === 'image') {
  const filters = [];

  // === Single Color Mode ===
  if (state.singleColorMode) {
    const color = state.singleColor || { r: 0, g: 0, b: 0 };

    filters.push(new fabric.Image.filters.Grayscale());
    filters.push(new fabric.Image.filters.BlendColor({
      color: `rgb(${color.r}, ${color.g}, ${color.b})`,
      mode: 'add',
      alpha: 1,
    }));

    obj.set({
      singleColorMode: true,
      singleColor: color,
    });
  } else {
    obj.set({ singleColorMode: false });
  }

  // === Make One Color Mode ===
  if (state.makeColorMode) {
    const color = state.makeColor || { r: 0, g: 0, b: 0 };

    filters.push(new fabric.Image.filters.BlendColor({
      color: `rgb(${color.r}, ${color.g}, ${color.b})`,
      mode: 'tint',
      alpha: 1,
    }));

    obj.set({
      makeColorMode: true,
      makeColor: color,
    });
  } else {
    obj.set({ makeColorMode: false });
  }

  // === Background Removal Mode ===
  if (state.bgRemove && state.dominant_color) {
    const color = state.dominant_color;
    const colorStr = `rgb(${color[0]}, ${color[1]}, ${color[2]})`;

    filters.push(new fabric.Image.filters.RemoveColor({
      color: colorStr,
      distance: 0.2,
      alpha: 1,
    }));

    obj.set({
      bgRemove: true,
      dominant_color: color,
    });
  } else {
    obj.set({
      bgRemove: false,
      dominant_color: null,
    });
  }

  obj.filters = filters;
  obj.applyFilters();
}


obj.setCoords();
obj.canvas?.renderAll();


  console.log("Object :",obj);

  // Apply image-specific properties
  if (obj.type === 'image' && state.src) {
    // Reload the image source if it has changed
    fabric.Image.fromURL(state.src, (img) => {
      obj.setElement(img.getElement());
      obj.setCoords();
      obj.set({
        paletteColors: state.paletteColors || [],
        src:state.src,
      });
      obj.canvas.renderAll();
            calculatePrice();

    },  {
  crossOrigin: 'anonymous'  // <== ✅ required for filter support
});
  }  else {
    // Apply path-based properties
    obj.set({
      originalPath: state.originalPath,
      warpType: state.warpType,
      curve: state.curve,
      curveTextSettings: state.curveTextSettings,
      bend: state.bend,
      distortH: state.distortH,
      distortV: state.distortV,
          fill: state.fill,
    });


    if (state.path) {
      obj.path = new fabric.Path(state.path).path;

        obj.setCoords();
    }

  if (obj.type === 'group' && state.objects) {
    obj.getObjects().forEach((child, index) => {
      const childState = state.objects[index];
      child.set({
        fill: childState.fill,
        stroke: childState.stroke || null,
        strokeWidth: childState.strokeWidth || 0,
        left: childState.left,
        top: childState.top,
        scaleX: childState.scaleX,
        scaleY: childState.scaleY,
        angle: childState.angle,
      });
      child.setCoords();
    });
  }

    obj.setCoords();
    obj.canvas.renderAll();
  }
};



  const addObjectFromHistoryState = (state, objId) =>
    new Promise((resolve) => {
      fabric.util.enlivenObjects([state], async function (objects) {
        const newObj = objects[0];

        if (!newObj) {
          resolve(null);
          return;
        }

        newObj.set({
          id: objId,
          designElement: state.designElement !== undefined ? state.designElement : true,
          isAddedText: state.isAddedText || Boolean(state.curveTextSettings),
          isAddedClipart: state.curveTextSettings ? false : state.isAddedClipart,
          curveTextSettings: state.curveTextSettings,
        });
        canvas.add(newObj);
        normalizeRestoredObjectPosition(newObj, state);
        newObj.setCoords();

        if (state.curveTextSettings) {
          const restoredObj = await applyObjectState(newObj, state);
          normalizeRestoredObjectPosition(restoredObj || newObj, state);
          resolve(restoredObj || newObj);
          return;
        }

        resolve(newObj);
      });
    });

  const deselectAllObjects = () => {
    if (canvas) {
      canvas.discardActiveObject();
      canvas.getActiveObjects().forEach((obj) => obj.set({ active: false }));
      canvas.renderAll();
    }
  };


  const saveObjectToLocalStorage = (obj, partName) => {
    if (!obj || !partName) return;

    const storageKey = `${designId}_${partName}`;
    let existingCanvasData = [];
    const existingDataJson = localStorage.getItem(storageKey);
    if (existingDataJson) {
      try {
        existingCanvasData = JSON.parse(existingDataJson);
      } catch (error) {
        console.error(`Failed to parse existing data for ${partName}:`, error);
      }
    }

    const objIndex = existingCanvasData.findIndex(existingObj => existingObj.id === obj.id);

    const newObjectData = {
      ...obj.toObject([
         'id','originKey','original_url',  'colorMap',
'originalPalette', 'topPercent', 'leftPercent', 'widthPercent', 'heightPercent', 'pathOffset', 'scaleX', 'scaleY',
        'type', 'left', 'top', 'width', 'height', 'designElement', /* 'ownMatrixCache', 'aCoords', */ 'path', 'fromWorkingArea',
        'scaleX', 'scaleY', 'zIndex', 'angle', 'stroke', 'element', 'selectable',
        'designElement', /* 'oCoords', */ 'selectable', 'strokeWidth', 'text', 'fontSize', 'fontWeight', 'fontFamily', 'textAlign',
        'fontStyle', 'lineHeight', 'letterSpacing', 'underline', 'overline', 'linethrough', 'clipPath', 'opacity', 'isAddedText',
        'designElement', 'isAddedClipart','session_id', 'src','dominant_color',     'newImagePath', // Ensure newImagePath is saved
            'imageFile', // Save the image file flag
            'imageType', // Save the image type
            'paletteColors','fill','originalPath' ,'bgRemove','clipartOriginalColors', 'clipartPath','singleColorMode','singleColor','makeColor','warpType','curve','curveTextSettings','filters','fontFamily','bend','stroke','originalText','strokeWidth' ,'bringToFront',
            'center','isFullColor','src' // Save the palette colors
      ]),
      zIndex: objIndex !== -1 ? objIndex : existingCanvasData.length
    };

    if (objIndex !== -1) {
      existingCanvasData[objIndex] = newObjectData;
    } else {
      existingCanvasData.push(newObjectData);
    }

    try {
      localStorage.setItem(storageKey, JSON.stringify(existingCanvasData));
      console.log(`Updated local storage for ${storageKey}:`, existingCanvasData);
    } catch (error) {
      console.error(`Failed to save data for ${storageKey}:`, error);
    }
  };

const removeObjectFromLocalStorage = (objId, partName) => {
  if (!objId || !partName) return;

  // ✅ use unified key that matches saveCanvasDataToLocalStorage
  const storageKey = `${designId}_${partName}`;

  let existingCanvasData = [];
  const existingDataJson = localStorage.getItem(storageKey);

  if (existingDataJson) {
    try {
      existingCanvasData = JSON.parse(existingDataJson);
    } catch (error) {
      console.error(`Failed to parse existing data for ${storageKey}:`, error);
    }
  }

  // ✅ same core logic as before
  const updatedCanvasData = existingCanvasData.filter(obj => obj.id !== objId);

  try {
    localStorage.setItem(storageKey, JSON.stringify(updatedCanvasData));
    console.log(`🗑 Removed object from local storage for ${storageKey}:`, objId);
  } catch (error) {
    console.error(`Failed to update data for ${storageKey}:`, error);
  }
};



  // const removeObjectFromLocalStorage = (objId, partName) => {
  //   if (!objId || !partName) return;

  //   let existingCanvasData = [];
  //   const existingDataJson = localStorage.getItem(partName);
  //   if (existingDataJson) {
  //     try {
  //       existingCanvasData = JSON.parse(existingDataJson);
  //     } catch (error) {
  //       console.error(`Failed to parse existing data for ${partName}:`, error);
  //     }
  //   }

  //   const updatedCanvasData = existingCanvasData.filter(obj => obj.id !== objId);

  //   try {
  //     localStorage.setItem(partName, JSON.stringify(updatedCanvasData));
  //     console.log(`Removed object from local storage for ${partName}:`, objId);
  //   } catch (error) {
  //     console.error(`Failed to update data for ${partName}:`, error);
  //   }
  // };



const undo = async () => {
  if (history.undo.length > 0) {
    const newHistory = { ...history };
    const lastChange = newHistory.undo.pop();
    const { objId, prevState, action } = lastChange;
    const obj = canvas.getObjectById(objId);

    deselectAllObjects();
    canvas.__isHistoryRestoring = true;

    try {
    if (action === 'removeGroup') {
      for (const item of lastChange.items || []) {
        if (!canvas.getObjectById(item.objId)) {
          const restoredObj = await addObjectFromHistoryState(item.prevState, item.objId);
          if (restoredObj) {
            updateObjectProportions(restoredObj);
            restoredObj.setCoords();
            restoredObj.originalState = restoredObj.toObject(historyObjectProps);
          }
        }
      }
    } else if (obj && obj.type === 'image') {

      // Handling for image objects
      if (action === 'add') {
        obj.set({
          opacity: 0,
          visible: false, // keep undone image fully hidden so it survives side switching (no ghost/empty bounding box)
          selectable: false,
          evented: false,
        });
         
      } else if (action === 'remove') {
        await applyObjectState(obj, prevState);
        obj.set({
          opacity: 1,
          visible: true, // restore visibility when the image is brought back (redo / undo of remove)
          selectable: true,
          evented: true,
        });

  } else if (action === 'modify' || action === 'colorChange' || action === 'strokeColorChange' || action === 'strokeWidthChange'|| action === 'rotationChange'|| action === 'singleColorToggle'|| action === 'curveTextChange') {        await applyObjectState(obj, prevState);
      }

    } else {
      // Handling for path and group objects
      if (action === 'add' && obj) {
        canvas.remove(obj);
      } else if (action === 'remove') {
        await addObjectFromHistoryState(prevState, objId);
      } else if ((action === 'modify' || action === 'colorChange'|| action === 'strokeColorChange' || action === 'strokeWidthChange'|| action === 'rotationChange'|| action === 'singleColorToggle'|| action === 'curveTextChange') && obj) {
        await applyObjectState(obj, prevState);
      }

    }

    if (obj && prevState && action !== 'add') {
      obj.originalState = { ...prevState };
      updateObjectProportions(obj);
      obj.setCoords();
    }
    } finally {
      canvas.__isHistoryRestoring = false;
    }

    canvas.renderAll();
    newHistory.redo.push(lastChange);
    setHistory(newHistory);
    canvas.discardActiveObject();
    onObjectSelected?.(null);

    calculatePrice();
    setTimeout(() => saveCanvasDataToLocalStorage(canvasKey), 0);
  }
};

const redo = async () => {
  if (history.redo.length > 0) {
    const newHistory = { ...history };
    const lastUndo = newHistory.redo.pop();
    const { objId, newState, action } = lastUndo;
    const obj = canvas.getObjectById(objId);

    deselectAllObjects();
    canvas.__isHistoryRestoring = true;

    try {
    if (action === 'removeGroup') {
      (lastUndo.items || []).forEach((item) => {
        const removedObj = canvas.getObjectById(item.objId);
        if (removedObj) {
          canvas.remove(removedObj);
        }
      });
    } else if (obj && obj.type === 'image') {
      // Handling for image objects
      if (action === 'add') {
        await applyObjectState(obj, newState);
        obj.set({
          opacity: 1,
          visible: true, // restore visibility when the image is brought back (redo / undo of remove)
          selectable: true,
          evented: true,
        });
      } else if (action === 'remove') {
        obj.set({
          opacity: 0,
          visible: false, // keep undone image fully hidden so it survives side switching (no ghost/empty bounding box)
          selectable: false,
          evented: false,
        });
  } else if (action === 'modify' || action === 'colorChange' || action === 'strokeColorChange' || action === 'strokeWidthChange'|| action === 'rotationChange'|| action === 'singleColorToggle'|| action === 'curveTextChange') {        await applyObjectState(obj, newState);
      }
    } else {
      // Handling for path and group objects
      if (action === 'remove' && obj) {
        canvas.remove(obj);
      } else if (action === 'add') {
        await addObjectFromHistoryState(newState, objId);
      } else if ((action === 'modify' || action === 'colorChange'|| action === 'strokeColorChange' || action === 'strokeWidthChange'|| action === 'rotationChange'|| action === 'singleColorToggle'|| action === 'curveTextChange') && obj) {
        await applyObjectState(obj, newState);
      }
    }

    if (obj && newState && action !== 'remove') {
      obj.originalState = { ...newState };
      updateObjectProportions(obj);
      obj.setCoords();
    }
    } finally {
      canvas.__isHistoryRestoring = false;
    }

    canvas.renderAll();
    newHistory.undo.push(lastUndo);
    setHistory(newHistory);
    canvas.discardActiveObject();
    onObjectSelected?.(null);
     calculatePrice();
    setTimeout(() => saveCanvasDataToLocalStorage(canvasKey), 0);
  }
};


  useEffect(() => {
    if (canvas) {
      const handleSelectionCleared = (e) => {
        const activeObjects = e.deselected;
        if (activeObjects) {
          activeObjects.forEach((obj) => updateObjectProportions(obj));
        }
      };

      canvas.on('selection:cleared', handleSelectionCleared);

      return () => {
        canvas.off('selection:cleared', handleSelectionCleared);
      };
    }
  }, [canvas, designArea]);

  const calculatePrice = () => {
    let additionalPrice = 0;
  
    if (switchBar === 'screenPrinting') {
      let colorSet = new Set();
      let hasFullColorImage = false;
  
      if (canvas) {
        canvas.getObjects().forEach((obj) => {
          if (obj.designElement && obj.opacity !== 0) { // Ensure object is visible
            const colors = extractColorsFromObject(obj);
            colors.forEach((color) => colorSet.add(color));
  
            // Check if the object is an image and has been flagged as sasasasasfull-color
            if (obj.type === 'image' && obj.isFullColor) {
              hasFullColorImage = true;
              console.log("hasFullColorImage",hasFullColorImage);
            }
          }
        });
      }
  
      let numberOfColors = hasFullColorImage ? 5 : colorSet.size; // Use full-color pricing if detected
      console.log("hasFullColorImage",numberOfColors);
      const quantityMatches = priceTableData.filter(item => item.Quantity === Number(quantity));
      console.log("Color Set:", numberOfColors);
      console.log("Quantity Matches:", quantityMatches);
  
      if (quantityMatches.length > 0) {
        const quantityData = quantityMatches[0];
        const firstColorPrice = quantityData["1st Color Price"];
        const additionalColorPrice = quantityData["2nd Color Price"];
        const fullColorPrice = quantityData["Full Color Price"];
  if (hasFullColorImage || numberOfColors > 4) {
  additionalPrice += fullColorPrice;
} else if (numberOfColors > 0) {
  additionalPrice += firstColorPrice;
  if (numberOfColors > 1) {
    additionalPrice += (numberOfColors - 1) * additionalColorPrice;
  }
}

      } else {
        console.error("No match found for quantity in Screen Printing pricing:", quantity);
      }
    }
    else if (switchBar === 'embroidery') {
      let hasColors = false;
      let hasFullColor = false;
    
      if (canvas) {
        canvas.getObjects().forEach((obj) => {
          if (obj.designElement && obj.opacity !== 0) { // Check if object is visible
            const colors = extractColorsFromObject(obj);
            if (colors.length > 0) {
              hasColors = true;
            }
            // Check if the object is an image and flagged as full-color
            if (obj.type === 'image' && obj.isFullColor) {
              hasFullColor = true;
            }
          }
        });
      }
    
      // If a full-color image is detected, treat it as having multiple colors
      if (hasFullColor) {
        hasColors = true;
        console.log("Full color detected. Treating design as having multiple colors.");
      }
    
      if (hasColors) {
        const quantityMatch = EmbrioderyPrice.find(item => item.Quantity === Number(quantity));
        if (quantityMatch) {
          additionalPrice = quantityMatch.Price;
        } else {
          console.error("No match found for quantity in Embroidery pricing:", quantity);
        }
      } else {
        console.log("No colors available on canvas for embroidery.");
      }
    }
    
  
    console.log("Additional Price:", additionalPrice);
    updateCanvasPrice(additionalPrice);
  };
  
  const captureDesignArea = () => {
    if (!canvas || !designArea) return;
  
    const { left, top, width, height } = designArea;
    const tempCanvasEl = document.createElement('canvas');
    tempCanvasEl.width = width;
    tempCanvasEl.height = height;
  
    const tempCanvas = new fabric.Canvas(tempCanvasEl);
  
    const designObjects = canvas.getObjects().filter(obj => obj.designElement && obj.opacity !== 0);
  
    Promise.all(designObjects.map(obj => new Promise(resolve => {
      obj.clone(clone => {
        clone.set({
          left: clone.left - left,
          top: clone.top - top,
        });
        resolve(clone);
      });
    }))).then(clones => {
      clones.forEach(clone => tempCanvas.add(clone));
      tempCanvas.renderAll();
  
      const dataURLFront = tempCanvas.toDataURL({
        format: 'png',
        quality: 1.0
      });
  
      console.log("Captured Design Area Image URL Front:", dataURLFront);
      setImagecaptureFront(dataURLFront); // Show the image somewhere on the page
  
      tempCanvas.dispose(); // Clean up
    });
  };
  
  
  useEffect(() => {
    if (isPriceSidebarVisible && canvas && designArea && influencerid) {
      captureDesignArea();
      console.log("Captured design area (influencerId exists):", influencerid);
    }
  }, [isPriceSidebarVisible, canvas, designArea, influencerid]);
  
  
  

  useEffect(() => {
    calculatePrice();
  },[quantity]);
  

  useEffect(() => {
    if (canvas) {
      canvas.on('object:added', calculatePrice);
      canvas.on('object:removed', calculatePrice);
      canvas.on('object:modified', calculatePrice);

      return () => {
        canvas.off('object:added', calculatePrice);
        canvas.off('object:removed', calculatePrice);
        canvas.off('object:modified', calculatePrice);
      };
    }
  }, [canvas]);

  const handleKeyDown = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'z') {
      e.preventDefault();
      undo();
    }
    if ((e.ctrlKey || e.metaKey) && e.key === 'y') {
      e.preventDefault();
      redo();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [history]);





 // UndoButton component
const UndoButton = ({ history, undo }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const getUndoIcon = () => {
    if (history.undo.length > 0) {
      return isHovered ? undoHoverImage : undoActiveImage;
    } else {
      return undoInactiveImage;
    }
  };

  return (
    <button
      onClick={undo}
      className="undobtn"
      disabled={history.undo.length === 0}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img src={getUndoIcon()} alt="Undo" width="28" height="28" />
    </button>
  );
};

// RedoButton component
const RedoButton = ({ history, redo }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const getRedoIcon = () => {
    if (history.redo.length > 0) {
      return isHovered ? redoHoverImage : redoActiveImage;
    } else {
      return redoInactiveImage;
    }
  };


  // const captureDesignArea = () => {
  //   if (!canvas || !designArea) return;
  
  //   const { left, top, width, height } = designArea;
  
  //   // Create a temporary canvas element
  //   const tempCanvasEl = document.createElement('canvas');
  //   tempCanvasEl.width = width;
  //   tempCanvasEl.height = height;
  
  //   const tempCanvas = new fabric.Canvas(tempCanvasEl);
  
  //   // Clone and offset design elements to fit in new canvas
  //   const designObjects = canvas.getObjects().filter(obj => obj.designElement && obj.opacity !== 0);
  
  //   designObjects.forEach(obj => {
  //     const clone = fabric.util.object.clone(obj);
  //     clone.set({
  //       left: clone.left - left,
  //       top: clone.top - top,
  //     });
  //     clone.setCoords();
  //     tempCanvas.add(clone);
  //   });
  
  //   tempCanvas.renderAll();
  
  //   // Get image data URL
  //   const dataURL = tempCanvas.toDataURL({
  //     format: 'png',
  //     quality: 1.0
  //   });
  
  //   // Optionally download
  //   const link = document.createElement('a');
  //   link.download = 'design-area.png';
  //   link.href = dataURL;
  //   link.click();
  // };
  

  return (
    <button
      onClick={redo}
      className="redobtn"
      disabled={history.redo.length === 0}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img src={getRedoIcon()} alt="Redo" width="28" height="28" />
    </button>
  );
};

console.log("ProductImage :",productImage);
console.log("DesignArea :", designArea);
  return (
    <div className={`canvas-area ${isPriceSidebarVisible ? 'canvas-area-none' : ''}`}>
      <canvas ref={canvasRef} />
      {canvas && <CustomBoundingBox controlSettings={controlSettings} canvas={canvas} />}
      {canvas && <ResizeLogicComponent canvas={canvas} productImage={productImage} />}
      {canvas && <DuplicateLogicComponent canvas={canvas} />}
      {canvas && (
        <ProductImageComponentOne
          canvas={canvas}
          setImage={setProductImage}
          selectedColor="#ffffff"
          setSelectedPart={setSelectedPart}
          setWorkingArea={setWorkingArea}
          activePart={activePart}
          setActivePart={setActivePart}
          Canvasid={Canvasid}
          pid={pid}
          switchBars={switchBar}
          setGetValue={setGetValue}
        />
      )}
      {canvas && productImage && (
        <WorkingAreaComponent
          canvas={canvas}
          image={productImage}
          workingArea={workingArea}
        />
      )}
      {canvas && productImage && (
        <DesignAreaComponentOne
          canvas={canvas}
          controlSettings={controlSettings}
          updateSelectedObjectSize={updateSelectedObjectSize}
          onObjectSelected={onObjectSelected}
          productImage={productImage}
          setDesignArea={setDesignArea}
          selectedPart={selectedPart}
          switchBar={switchBar}
          isPriceSidebarVisible={isPriceSidebarVisible}
        />
      )}
   <div className={`undo-redo-buttons ${isPriceSidebarVisible ? 'undo-redo-buttons-visible' : ''}`}>
  <UndoButton history={history} undo={undo} />
  <RedoButton history={history} redo={redo} />
  {/* <button onClick={captureDesignArea} className="capture-btn">
  Capture Design Area
</button> */}

  
</div>

    </div>
  );
};

export default CanvasComponentOne;
